import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  async getConfiguration(configurationCode, deliveryDateTime, calculateBpm = null) {
    const params = {
      configurationCode,
      deliveryDateTime,
      calculateBpm,
    }

    try {
      const response = await axios.get('getConfiguration', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      }

      return Promise.reject(e)
    }
  },
  async getStockcar(stockCarId, deliveryDateTime, calculateBpm = null) {
    const params = {
      stockCarId: stockCarId,
      deliveryDateTime: deliveryDateTime,
      calculateBpm: calculateBpm,
    }

    try {
      const response = await axios.get('GetStockCarById', { params })
      return response.data
    } catch (e) {
      if (e.response.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getStock(stockId, deliveryDateTime, calculateBpm) {
    const params = {
      stockId: stockId,
      deliveryDateTime: deliveryDateTime,
      calculateBpm: calculateBpm,
      extendedConfiguration: false,
    }
    try {
      const response = await passThroughAxios.get('stockcarsNew/stock', { params })
      return response.data
    } catch (e) {
      if (e.response.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getShoppingCart(cartId) {
    const params = {
      cartId: cartId,
    }

    try {
      const response = await axios.get('getShoppingCart', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      }

      return Promise.reject(e)
    }
  },
}
